import LoadingButton from 'components/Common/LoadingButton';
import { axiosbaseurl } from 'configure';
import { validateContact } from 'helpers/common_helper';
import { setUpdatedData } from 'helpers/data_setters';
import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "reactstrap"


const EditSingleItem = ({ show, setShow, settable_data, itemName, setItemName, item_id, api_name, heading,
    fieldName, isBudgetMaster = false, budgetAmt }) => {

    // Individual states for each field
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    // reset states
    useEffect(() => {
        if (!show) {
            setItemName("")
            if (isBudgetMaster) {
                budgetAmt.setValue('')
            }
            setError("")
        }
    }, [show])

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault()
        // Guard: service-master id 2 is non-editable
        if (api_name === "service-master" && Number(item_id) === 2) {
            swal("", "This service (ID 2) is non-editable and cannot be updated.", "warning")
            return
        }
        try {
            if (itemName) {
                setLoading(true)
                const response = await axiosbaseurl.put(`/${api_name}/${item_id}`,
                    {
                        [fieldName]: itemName,
                        ...(isBudgetMaster ? { value: budgetAmt.value } : {})
                    });

                show && setShow(false);
                settable_data(prev => setUpdatedData(prev, response.data.data || response.data.status, "edit"))
                setItemName("")
            }
        } catch (error) {
            setError(error.response.data.message)
            setTimeout(() => setError(""), 5000)
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal size="md" isOpen={show} toggle={() => setShow(!show)} centered={true}>
            <div className="modal-content">
                <ModalBody className="px-3 ">
                    <div className='d-flex justify-content-between  pb-2 border-bottom'>
                        <h5 className='text-capitalize'>Edit {heading}</h5>
                        <button type="button" className="btn-close " onClick={() => setShow(!show)}></button>
                    </div>
                    <div>
                        {
                            error && <div className="alert alert-danger">{error}</div>
                        }
                    </div>

                    <form onSubmit={handleSubmit} className='mt-4'>
                        <div className="mb-3">
                            <label className='text-capitalize'>{heading} Name <span className='text-danger'>*</span></label>
                            <input
                                type="text"
                                placeholder={`Enter ${heading}`}
                                value={itemName}
                                onChange={(e) => setItemName(e.target.value)}
                                className="form-control input-field"
                                required
                            />
                        </div>

                        {
                            isBudgetMaster ?
                                <div className="mb-3">
                                    <label className='text-capitalize'>Cost Per Hour (£) <span className='text-danger'>*</span></label>
                                    <input
                                        type="text"
                                        placeholder={`Enter Cost`}
                                        value={budgetAmt.value}
                                        onChange={(e) => budgetAmt.setValue(e.target.value)}
                                        onKeyDown={validateContact}
                                        className="form-control input-field"
                                        required
                                    />
                                </div>
                                : null
                        }

                        <div className='text-center mt-4'>
                            <LoadingButton loading={loading} />

                        </div>

                    </form>

                </ModalBody>
            </div>
        </Modal>
    )
}

export default EditSingleItem